import {DrugItemDrawerMedicationProfilesSection} from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import {useSupportiveMedicationDrugContext} from '@/shared/contexts/supportive-medication-drug'
import {Tabs} from '@chakra-ui/react'

export function MedicationProfilesTab() {
  const {supportiveMedicationDrug} = useSupportiveMedicationDrugContext()

  return (
    <Tabs.Content value="medication-profiles">
      <DrugItemDrawerMedicationProfilesSection drugItem={supportiveMedicationDrug} />
    </Tabs.Content>
  )
}
